import React from "react";
import ProductionOrderView from "./ProductionOrderView";
import useProductionOrder from "./useProductionOrder";

function ProductionOrder() {
  return <ProductionOrderView {...useProductionOrder()} />;
}

export default ProductionOrder;
